import { render, staticRenderFns } from "./belegsearch.vue?vue&type=template&id=66da2a5f&scoped=true"
import script from "./belegsearch.vue?vue&type=script&lang=js"
export * from "./belegsearch.vue?vue&type=script&lang=js"
import style0 from "./belegsearch.vue?vue&type=style&index=0&id=66da2a5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66da2a5f",
  null
  
)

/* custom blocks */
import block0 from "./belegsearch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports